<template>
  <v-footer
    color="#FFFFFF"
    style="margin-top: auto; border-top: 1px solid #000000"
    class="app-footer footer-lining black--text"
  >
    <v-row no-gutters justify="center" align="center" class="py-2">
      <v-col cols="12" class="footer-content">
        <span
          class="footer-lining-text black--text"
          style="margin-bottom: 2px; font-size: 16px"
        >
          Copyright © 2026 Forward System Limited.
        </span>
      </v-col>
    </v-row>
  </v-footer>
</template>
<script>
export default {
  data() {
    return {};
  },
};
</script>
<style>
@font-face {
  font-family: "Mrs Eaves Lining OT";
  src: url("~@/assets/Font/Lining.otf") format("opentype");
  font-style: normal;
  font-weight: 400;
  font-display: swap;
}

.v-footer.footer-lining,
.v-footer.footer-lining .footer-lining-text {
  font-family: "Mrs Eaves Lining OT", serif !important;
  font-weight: 400;
}

.footer-content {
  display: flex;
  align-items: center;
  justify-content: center;
}

.footer-lining-text {
  text-align: center;
}

.inline-container {
  text-align: center;
}

.inline-item {
  display: inline-block;
  vertical-align: middle;
}

.inline-container span {
  font-size: small;
  margin-bottom: 5px;
  color: black;
}
</style>
